<template>
    <div>
        <v-card class="my-1">
            <vue-signature-pad
                ref="signaturePad"
                width="100%"
                height="12.5rem"
                :options="{
                    onBegin,
                    onEnd,
                }" />
        </v-card>
        <div class="d-flex">
            <v-messages
                class="flex-grow-1"
                :role="hasMessages ? 'alert' : null"
                :value="messagesToDisplay"
                :color="hasHint ? '' : validationState" />
            <v-btn @click="clear">
                Clear
            </v-btn>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import VueSignaturePad from "vue-signature-pad";
import VInput from "vuetify/lib/components/VInput/VInput.js";

Vue.use(VueSignaturePad);

export default {
    extends: VInput,

    data() {
        return {};
    },
    computed: {
        signaturePad() {
            return this.$refs.signaturePad;
        },
    },
    methods: {
        clear() {
            this.signaturePad.clearSignature();
            this.$emit("input", null);
        },
        onEnd() {
            let signature = this.signaturePad.saveSignature("image/svg+xml");
            let value = signature.isEmpty ? null : signature.data;
            this.$emit("input", value);
        },
        onBegin() {
            this.signaturePad.resizeCanvas();
        },
    },
}
</script>
